import React from "react";

export default function SectionHeading({ heading }) {
  return <h1 className="mark">{heading}</h1>;
}
